module.exports = __webpack_public_path__ + "img/hero-classics3-le_mattjones.71ba2b8.jpg";